// React import not needed with new JSX runtime
import { Box, Avatar, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { getColorFromHash } from 'utils/ColorUtils';

/**
 * OwnerHeader renders the channel avatar and title on a gradient banner.
 */
const HeaderBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'lingo',
})<{
  /** Language code (lingo) to determine header style */
  lingo?: string;
}>(({ theme, lingo }) => ({
  background:
    lingo?.toLowerCase() === 'uk'
      ? 'linear-gradient(to right, #1e40af, #ffd700)'
      : 'linear-gradient(to right, #1e40af, #ef233c)',
  color: '#FFFFFF',
  borderBottomLeftRadius: theme.shape.borderRadius * 2,
  borderBottomRightRadius: theme.shape.borderRadius * 2,
  boxShadow: theme.shadows[2],
  // Fixed header height; content vertically centered
  height: theme.spacing(17),
  display: 'flex',
  alignItems: 'center',
}));

export default function OwnerHeader({
  title,
  avatarUrl,
  /** Language code (ownerLingo) to determine header style */
  lingo,
}: {
  title: string;
  avatarUrl?: string;
  lingo?: string;
}) {
  return (
    <HeaderBox lingo={lingo}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, px: { xs: 1, sm: 2 } }}>
        <Avatar
          src={avatarUrl}
          alt={title}
          sx={{
            width: 72,
            height: 72,
            fontSize: '36px',
            bgcolor: getColorFromHash(title),
          }}
        />
        <Typography
          variant="h4"
          component="h2"
          sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600 }}
        >
          {title}
        </Typography>
      </Box>
    </HeaderBox>
  );
}